<template>
  <div class="ShowRoom">
    <div class="inner">
        <div class="container">
            <b-row class="bodySection">
                <b-col lg="4" sm="12">
                    <h2 class="title">Call Us Today</h2>
                    <p class="text" v-html="showRoomData.call_us_text"></p>
                    <h2 class="extraInfo" v-html="showRoomData.call_us_extra_text"></h2>
                </b-col>
                <b-col lg="4" sm="12">
                    <h2 class="title">Get In Touch</h2>
                    <Form/>
                </b-col>
                <b-col lg="4" sm="12">
                    <h2 class="title">Arrange a Demo</h2>
                    <p class="text" v-html="showRoomData.arrange_demo_text"></p>
                    <h2 class="extraInfo" v-html="showRoomData.arrange_demo_extra_text"></h2>
                </b-col>
            </b-row>
        </div>
    </div>
    <div class="contactArea">
        <img class="bottomImage" src="https://wp-ocssport.ocs-sport.com/imsim-uk/wp-content/uploads/sites/8/2025/02/Contact_Image_Tiles.png">
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Form from '@/components/showRoomForm.vue'
export default {
  name: 'ShowRoom',
  components: {
    Form
  },
  data: function() {
    return {
      acf: [],
      showRoomData: []
    };
  },
  methods: {
    isMobile() {
        if( screen.width <= 500 ) {
            return true;
        }
        else {
            return false;
        }
    },
  },
  mounted() {
    axios //add API Call
        .get(
            process.env.VUE_APP_API_URL + 'imsim-uk' + "/wp-json/wp/v2/pages/81" + '?randomadd=' +
          new Date().getTime()
        ) // Page number changed on each page based on JSON page id you are calling
        .then((response) => (
            this.acf = response.data,
            this.showRoomData = response.data.acf
        )); //API data wanted pulled out
  },
}
</script>

<style scoped>
p.text {
    color: #fff;
    font-size: 18px;
    text-align: left;
    padding-top: 60px;
    padding-bottom: 5px;
}
h2.extraInfo {
    font-weight: bold;
    font-size: 24px;
    text-align: left;
}
.bodySection {
    padding-top: 150px;
}
h2.title {
    color: #FD021D;
    font-weight: bold;
    font-size: 30px;
    text-align: left;
}
.bottomImage {
    width: 100%;
}
.inner {
    background-image: url(https://wp-ocssport.ocs-sport.com/imsim-uk/wp-content/uploads/sites/8/2025/02/Contact_Background.png);
    background-repeat: no-repeat;
    height: 1000px;
    background-position: center;
    background-size: cover;
}
.contactArea {
    background-color: #FD021D;
}
.contactTitle {
    color: #000000;
    font-size: 40px;
    font-weight: bold;
    text-align: left;
    margin-top: 200px;
    padding-bottom: 30px;
}
p.contactText {
    color: #fff;
    font-size: 25px;
    font-weight: bold;
    text-align: left;
    margin-bottom: 200px;
}
.mainHeader {
    color: #FD021D;
    font-size: 60px;
    font-weight: bold;
    text-align: left;
    margin-top: 150px;
}
.subHeader {
    color: #FFFFFF;
    font-size: 50px;
    font-weight: bold;
    text-align: left;
    margin-top: 30px;
}
.mainText {
    font-size: 18px;
    font-weight: bold;
    text-align: left;
    margin-top: 50px;
}
.linksBelow {
    margin-top: 50px;
}
button.accessBTN {
    width: 100%;
    height: 65px;
    background-color: #FD021D;
    border: none;
    color: #fff;
    font-weight: bold;
}
.youtube {
    width: 90px;
    position: absolute;
    top: -10px;
    right: -50px;
}
@media only screen and (max-width: 768px) {
    .bodySection {
        padding-top: 50px;
    }
    p.text {
        color: #fff;
        font-size: 18px;
        text-align: left;
        padding-top: 30px;
        padding-bottom: 5px;
    }
    .inner {
        height: auto;
        padding-bottom: 45px;
    }
}
</style>
